/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */
import isArray from 'lodash.isarray';
import {CreateQueryParams, createSearchFilters, normalize} from './Query';
import {Query} from './types';

export const generatePlatformsQuery = (query: keyof Query, {
  fields, search
}: CreateQueryParams): string => {
  const newline = ',\n';
  let isNumberArray = false;
  Object.entries(search?.filter)?.forEach(([prop, value]) => {
    if (isArray(value)) {
      isNumberArray = prop === 'deviceId';
    }
  });

  let document  = '{';
  if (search) {
    document += `
      ${query}(${createSearchFilters(search, true, isNumberArray)}) {
        platforms {
          ${normalize(fields, newline)}
        }
      }`;
  } else {
    document += `
      ${query} {
        ${normalize(fields, newline)}
      }`;
  }
  document += '}';
  return document;
};
